import React, { useState, useEffect } from 'react';
import { ref, onValue, push, remove, set } from 'firebase/database';
import { database } from '../firebase';
import './AdminPanel.css';

const AdminPanel = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [activeTab, setActiveTab] = useState('products');
  
  // Ürünler: başlık (kategori) + alt ürünler
  const [productCategories, setProductCategories] = useState([]);
  const [newCategoryTitle, setNewCategoryTitle] = useState('');
  const [newItemByCategory, setNewItemByCategory] = useState({});
  const [newSubCategoryTitleByCat, setNewSubCategoryTitleByCat] = useState({}); // { categoryId: 'Alt başlık adı' }
  const [newItemBySubCategory, setNewItemBySubCategory] = useState({}); // { 'catId_subId': { title: '', description: '' } }
  
  // S.S.S.
  const [faqs, setFaqs] = useState([]);
  const [newFaq, setNewFaq] = useState({ question: '', answer: '' });
  
  // Blog
  const [blogPosts, setBlogPosts] = useState([]);
  const [newBlog, setNewBlog] = useState({ title: '', excerpt: '', content: '', date: '' });
  
  // Haber
  const [newsItems, setNewsItems] = useState([]);
  const [newNews, setNewNews] = useState({ title: '', excerpt: '', content: '', date: '' });
  
  // İletişim Bilgileri
  const [contactInfo, setContactInfo] = useState({
    phone: '0534 343 71 23',
    email: '',
    address: 'KARTALTEPE MAH CİCOZ YOLU CAD SÜMBÜL SOKAK NO52A BAYRAMPAŞA, Istanbul, Turkey 34400',
    workingHours: 'Pazartesi - Cuma: 09:00 - 18:00\nCumartesi: 09:00 - 14:00',
    youtube: '',
    instagram: '',
    tiktok: ''
  });

  // Basit şifre kontrolü
  const ADMIN_PASSWORD = 'bulut.2026!';

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setPassword('');
    } else {
      alert('Yanlış şifre!');
    }
  };

  // Realtime Database'den veri dinle
  useEffect(() => {
    if (!isAuthenticated) return;

    // Ürün kategorilerini dinle (başlık + alt ürünler)
    const categoriesRef = ref(database, 'productCategories');
    const unsubscribeProducts = onValue(categoriesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data)
          .map(key => {
            const cat = data[key];
            let subCategories = [];
            const legacyItems = (cat.items && Object.keys(cat.items).length > 0)
              ? Object.keys(cat.items).map(iid => ({
                  id: iid,
                  title: cat.items[iid].title || '',
                  description: cat.items[iid].description || ''
                }))
              : [];
            if (cat.subCategories && Object.keys(cat.subCategories).length > 0) {
              const fromSub = Object.keys(cat.subCategories)
                .map(sid => {
                  const sub = cat.subCategories[sid];
                  const items = (sub.items && Object.keys(sub.items).length > 0)
                    ? Object.keys(sub.items).map(iid => ({
                        id: iid,
                        title: sub.items[iid].title || '',
                        description: sub.items[iid].description || ''
                      }))
                    : [];
                  return { id: sid, title: sub.title || '', order: sub.order ?? 999, items };
                })
                .sort((a, b) => a.order - b.order);
              if (legacyItems.length > 0) subCategories = [{ id: 'genel', title: 'Genel', order: -1, items: legacyItems }, ...fromSub];
              else subCategories = fromSub;
            } else if (legacyItems.length > 0) {
              subCategories = [{ id: 'genel', title: 'Genel', order: 0, items: legacyItems }];
            }
            return {
          id: key,
              title: cat.title || '',
              order: cat.order ?? 999,
              subCategories
            };
          })
          .sort((a, b) => a.order - b.order);
        setProductCategories(list);
      } else {
        setProductCategories([]);
      }
    });

    // S.S.S. dinle
    const faqRef = ref(database, 'faq');
    const unsubscribeFaq = onValue(faqRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setFaqs(Object.keys(data).map(key => ({ id: key, ...data[key] })));
      } else {
        setFaqs([]);
      }
    });

    // Blog dinle
    const blogRef = ref(database, 'blog');
    const unsubscribeBlog = onValue(blogRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setBlogPosts(Object.keys(data).map(key => ({ id: key, ...data[key] })));
      } else {
        setBlogPosts([]);
      }
    });

    // Haber dinle
    const newsRef = ref(database, 'news');
    const unsubscribeNews = onValue(newsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setNewsItems(Object.keys(data).map(key => ({ id: key, ...data[key] })));
      } else {
        setNewsItems([]);
      }
    });

    // İletişim bilgilerini yükle
    const contactRef = ref(database, 'contactInfo');
    onValue(contactRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setContactInfo(data);
      }
    });

    return () => {
      unsubscribeProducts();
      unsubscribeFaq();
      unsubscribeBlog();
      unsubscribeNews();
    };
  }, [isAuthenticated]);

  // Başlık (kategori) ekle
  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!newCategoryTitle.trim()) return;
    const categoriesRef = ref(database, 'productCategories');
    await push(categoriesRef, {
      title: newCategoryTitle.trim(),
      order: productCategories.length,
      subCategories: {},
      items: {}
    });
    setNewCategoryTitle('');
    alert('Başlık eklendi!');
  };

  // Alt başlık (subCategory) ekle
  const handleAddSubCategory = async (e, categoryId) => {
    e.preventDefault();
    const title = (newSubCategoryTitleByCat[categoryId] || '').trim();
    if (!title) return;
    const cat = productCategories.find(c => c.id === categoryId);
    const subCount = (cat?.subCategories?.length || 0);
    const subRef = ref(database, `productCategories/${categoryId}/subCategories`);
    await push(subRef, { title, order: subCount, items: {} });
    setNewSubCategoryTitleByCat(prev => ({ ...prev, [categoryId]: '' }));
    alert('Alt başlık eklendi!');
  };

  // Alt başlık sil
  const handleDeleteSubCategory = async (categoryId, subId) => {
    if (subId === 'genel') return;
    if (!window.confirm('Bu alt başlığı ve altındaki tüm hizmetleri silmek istediğinize emin misiniz?')) return;
    await remove(ref(database, `productCategories/${categoryId}/subCategories/${subId}`));
  };

  // Hizmet ekle (alt başlık altına veya kategoriye - genel ise items'a)
  const handleAddProductItem = async (e, categoryId, subCategoryId) => {
    e.preventDefault();
    const key = `${categoryId}_${subCategoryId}`;
    const raw = newItemBySubCategory[key] || newItemByCategory[categoryId];
    const title = (typeof raw === 'string' ? raw : raw?.title || '').trim();
    if (!title) return;
    const description = (typeof raw === 'object' && raw?.description ? raw.description : '').trim();
    const content = (typeof raw === 'object' && raw?.content ? raw.content : '').trim();
    const payload = { title, description: description || '', content: content || '' };
    if (subCategoryId === 'genel') {
      const itemsRef = ref(database, `productCategories/${categoryId}/items`);
      await push(itemsRef, payload);
    } else {
      const itemsRef = ref(database, `productCategories/${categoryId}/subCategories/${subCategoryId}/items`);
      await push(itemsRef, payload);
    }
    setNewItemBySubCategory(prev => ({ ...prev, [key]: { title: '', description: '', content: '' } }));
    setNewItemByCategory(prev => ({ ...prev, [categoryId]: { title: '', description: '' } }));
    alert('Hizmet eklendi!');
  };

  // Başlık (kategori) sil
  const handleDeleteCategory = async (id) => {
    if (!window.confirm('Bu başlığı ve altındaki tüm hizmetleri silmek istediğinize emin misiniz?')) return;
    await remove(ref(database, `productCategories/${id}`));
  };

  // Hizmet sil (genel ise items'tan, değilse subCategories altından)
  const handleDeleteProductItem = async (categoryId, subCategoryId, itemId) => {
    if (!window.confirm('Bu hizmeti silmek istediğinize emin misiniz?')) return;
    if (subCategoryId === 'genel') {
      await remove(ref(database, `productCategories/${categoryId}/items/${itemId}`));
    } else {
      await remove(ref(database, `productCategories/${categoryId}/subCategories/${subCategoryId}/items/${itemId}`));
    }
  };

  // Demo mock veri: Eğitim ve Belgelendirme – her birinde ISO 9001, 14001, 27001, 45001
  const MOCK_PRODUCT_CATEGORIES = {
    cat1: {
      title: 'Eğitim',
      order: 0,
      subCategories: {},
      items: {
        i1: {
          title: 'ISO 9001 Kalite Yönetim Sistemi Eğitimi',
          description: 'Kalite yönetim sistemi temel ve iç denetçi eğitimleri.',
          content: 'ISO 9001:2015 Kalite Yönetim Sistemi eğitimlerimiz; temel farkındalık, dokümantasyon ve iç denetçi modüllerini kapsar. Kurumunuzun kalite süreçlerini standarta uygun yönetebilmesi ve iç denetim yapabilmesi için gerekli bilgi ve becerileri aktarıyoruz. Eğitim sonunda katılım belgesi düzenlenir.'
        },
        i2: {
          title: 'ISO 14001 Çevre Yönetim Sistemi Eğitimi',
          description: 'Çevre yönetim sistemi ve çevresel risk eğitimleri.',
          content: 'ISO 14001:2015 Çevre Yönetim Sistemi eğitimleri; çevre politikası, önemli çevresel etkiler, uyum yükümlülükleri ve iç denetim konularını içerir. Sürdürülebilirlik ve çevresel performans yönetimi için gerekli yetkinlikleri kazandırıyoruz.'
        },
        i3: {
          title: 'ISO 27001 Bilgi Güvenliği Yönetim Sistemi Eğitimi',
          description: 'Bilgi güvenliği ve ISMS farkındalık eğitimleri.',
          content: 'ISO 27001 Bilgi Güvenliği Yönetim Sistemi (ISMS) eğitimleri; bilgi varlıklarının korunması, risk değerlendirme, kontrol tedbirleri ve iç denetim süreçlerini kapsar. Kurumunuzun siber güvenlik ve veri koruma gereksinimlerine yönelik farkındalık ve uygulama becerisi kazandırıyoruz.'
        },
        i4: {
          title: 'ISO 45001 İş Sağlığı ve Güvenliği Yönetim Sistemi Eğitimi',
          description: 'İş sağlığı ve güvenliği yönetim sistemi eğitimleri.',
          content: 'ISO 45001 İş Sağlığı ve Güvenliği Yönetim Sistemi (OH&S) eğitimleri; tehlike analizi, risk değerlendirme, yasal uyum ve OH&S performansının iyileştirilmesi konularını içerir. İş kazaları ve meslek hastalıklarının önlenmesi için sistemli bir yaklaşım sunuyoruz.'
        }
      }
    },
    cat2: {
      title: 'Belgelendirme',
      order: 1,
      subCategories: {},
      items: {
        i1: {
          title: 'ISO 9001 Kalite Yönetim Sistemi Belgelendirme',
          description: 'ISO 9001 belgesi alımı ve denetim hazırlık danışmanlığı.',
          content: 'ISO 9001 Kalite Yönetim Sistemi belgelendirme sürecinde; mevcut durum analizi, dokümantasyon hazırlığı, sistem kurulumu ve belgelendirme kuruluşu denetimine hazırlık danışmanlığı sunuyoruz. Belge alımı sonrası gözetim denetimleri için de destek veriyoruz.'
        },
        i2: {
          title: 'ISO 14001 Çevre Yönetim Sistemi Belgelendirme',
          description: 'ISO 14001 belgesi alımı ve çevre yönetimi danışmanlığı.',
          content: 'ISO 14001 Çevre Yönetim Sistemi belgelendirme sürecinde; çevresel boyut analizi, çevre politikası ve hedeflerinin oluşturulması, prosedürlerin hazırlanması ve denetim sürecine kadar rehberlik ediyoruz.'
        },
        i3: {
          title: 'ISO 27001 Bilgi Güvenliği Yönetim Sistemi Belgelendirme',
          description: 'ISO 27001 ISMS belgesi ve bilgi güvenliği danışmanlığı.',
          content: 'ISO 27001 Bilgi Güvenliği Yönetim Sistemi belgelendirmesinde; bilgi varlığı envanteri, risk değerlendirme, SoA (Statement of Applicability) ve gerekli kontrollerin uygulanması aşamalarında danışmanlık sağlıyoruz.'
        },
        i4: {
          title: 'ISO 45001 İş Sağlığı ve Güvenliği Yönetim Sistemi Belgelendirme',
          description: 'ISO 45001 OH&S belgesi ve iş güvenliği danışmanlığı.',
          content: 'ISO 45001 İş Sağlığı ve Güvenliği Yönetim Sistemi belgelendirmesinde; tehlike ve risk değerlendirmesi, yasal uyum, OH&S hedefleri ve operasyonel kontrollerin kurulması sürecinde yanınızdayız.'
        }
      }
    }
  };

  const handleLoadMockProductCategories = async () => {
    if (!window.confirm('Demo başlık ve hizmet listesi yüklenecek. Mevcut hizmet verisi silinip değiştirilecek. Devam?')) return;
    await set(ref(database, 'productCategories'), MOCK_PRODUCT_CATEGORIES);
    alert('Demo veri yüklendi!');
  };

  // S.S.S. ekle
  const handleAddFaq = async (e) => {
    e.preventDefault();
    if (newFaq.question && newFaq.answer) {
      const faqRef = ref(database, 'faq');
      await push(faqRef, {
        question: newFaq.question,
        answer: newFaq.answer,
        createdAt: new Date().toISOString()
      });
      setNewFaq({ question: '', answer: '' });
      alert('Soru eklendi!');
    }
  };

  const handleDeleteFaq = async (id) => {
    if (window.confirm('Bu soruyu silmek istediğinize emin misiniz?')) {
      await remove(ref(database, `faq/${id}`));
    }
  };

  const MOCK_FAQ = [
    { question: 'Mesleki yeterlik belgesi nedir?', answer: 'Mesleki yeterlik belgesi, ilgili meslekte çalışabilmek için gerekli bilgi ve becerileri belgeleyen resmi bir sertifikadır. Eğitim ve sınav sürecinin ardından yetkili kurumlarca verilir.' },
    { question: 'İSO belgesi ne işe yarar?', answer: 'İSO belgeleri (9001, 14001, 22000, 27001 vb.) işletmenizin kalite, çevre, gıda güvenliği veya bilgi güvenliği yönetim sistemlerine sahip olduğunu gösterir. İhale ve müşteri güveni için önemlidir.' },
    { question: 'KOSGEB desteklerinden kimler yararlanabilir?', answer: 'KOSGEB desteklerinden KOBİ statüsündeki işletmeler, yeni girişimciler ve belirli projeleri olan firmalar yararlanabilir. Başvuru koşulları destek türüne göre değişir.' },
    { question: 'Danışmanlık hizmeti süresi ne kadardır?', answer: 'Danışmanlık hizmetinin süresi ihtiyacınıza ve proje kapsamına göre değişir. İlk görüşmede süre ve aşamalar birlikte belirlenir.' },
    { question: 'Eğitimler yüz yüze mi online mı?', answer: 'Hem yüz yüze hem online eğitim seçeneklerimiz mevcuttur. Program türüne göre bilgi alabilirsiniz.' }
  ];

  const handleLoadMockFaq = async () => {
    if (!window.confirm(MOCK_FAQ.length + ' adet örnek S.S.S. eklenecek. Devam?')) return;
    const faqRef = ref(database, 'faq');
    for (const item of MOCK_FAQ) {
      await push(faqRef, { question: item.question, answer: item.answer, createdAt: new Date().toISOString() });
    }
    alert('Demo S.S.S. verisi yüklendi!');
  };

  // Blog ekle
  const handleAddBlog = async (e) => {
    e.preventDefault();
    if (newBlog.title && (newBlog.excerpt || newBlog.content)) {
      const blogRef = ref(database, 'blog');
      await push(blogRef, {
        title: newBlog.title,
        excerpt: newBlog.excerpt || '',
        content: newBlog.content || newBlog.excerpt,
        date: newBlog.date || new Date().toISOString(),
        createdAt: new Date().toISOString()
      });
      setNewBlog({ title: '', excerpt: '', content: '', date: '' });
      alert('Blog yazısı eklendi!');
    }
  };

  const handleDeleteBlog = async (id) => {
    if (window.confirm('Bu yazıyı silmek istediğinize emin misiniz?')) {
      await remove(ref(database, `blog/${id}`));
    }
  };

  const MOCK_BLOG = [
    { title: 'Mesleki Yeterlik Belgesi Nasıl Alınır?', excerpt: 'Mesleki yeterlik belgesi alma süreci, gerekli eğitimler ve başvuru adımları hakkında bilmeniz gerekenler.', date: '2025-01-15' },
    { title: 'İSO 9001 Kalite Yönetim Sistemi Nedir?', excerpt: 'İSO 9001 standardı, işletmelerde kalite yönetiminin temel prensiplerini ve belgelendirme sürecini anlatıyoruz.', date: '2025-01-10' },
    { title: 'KOSGEB Hibe ve Destekler 2025', excerpt: 'KOSGEB\'in güncel destek programları, başvuru koşulları ve süreçleri hakkında güncel bilgiler.', date: '2025-01-05' },
    { title: 'Kalkınma Ajansı Proje Döngüsü', excerpt: 'Kalkınma ajanslarına proje yazarken dikkat edilmesi gerekenler ve proje döngüsü yönetimi.', date: '2024-12-20' },
    { title: 'Küçük İşletmeler İçin Belgelendirme Rehberi', excerpt: 'KOBİ\'lerin ihtiyaç duyabileceği belgeler ve bu belgelere nasıl hazırlanılacağına dair özet rehber.', date: '2024-12-01' }
  ];

  const handleLoadMockBlog = async () => {
    if (!window.confirm(MOCK_BLOG.length + ' adet örnek blog yazısı eklenecek. Devam?')) return;
    const blogRef = ref(database, 'blog');
    for (const item of MOCK_BLOG) {
      await push(blogRef, {
        title: item.title,
        excerpt: item.excerpt,
        content: item.excerpt,
        date: item.date,
        createdAt: new Date().toISOString()
      });
    }
    alert('Demo blog verisi yüklendi!');
  };

  // Haber ekle
  const handleAddNews = async (e) => {
    e.preventDefault();
    if (newNews.title && (newNews.excerpt || newNews.content)) {
      const newsRef = ref(database, 'news');
      await push(newsRef, {
        title: newNews.title,
        excerpt: newNews.excerpt || '',
        content: newNews.content || newNews.excerpt,
        date: newNews.date || new Date().toISOString(),
        createdAt: new Date().toISOString()
      });
      setNewNews({ title: '', excerpt: '', content: '', date: '' });
      alert('Haber eklendi!');
    }
  };

  const handleDeleteNews = async (id) => {
    if (window.confirm('Bu haberi silmek istediğinize emin misiniz?')) {
      await remove(ref(database, `news/${id}`));
    }
  };

  const MOCK_NEWS = [
    { title: 'Yeni Dönem Mesleki Yeterlik Eğitimleri Başlıyor', excerpt: 'Mesleki yeterlik belgesi eğitim programlarımızın yeni dönem kayıtları başladı. Detaylar için iletişime geçin.', date: '2025-02-01' },
    { title: 'İSO 27001 Bilgi Güvenliği Eğitimi Duyurusu', excerpt: 'Bilgi güvenliği yönetim sistemi (İSO 27001) eğitim tarihleri ve kayıt koşulları açıklandı.', date: '2025-01-25' },
    { title: 'KOSGEB 2025 Destek Programları Açıklandı', excerpt: 'KOSGEB\'in bu yıl açacağı destek ve hibe programlarına dair ön bilgilendirme.', date: '2025-01-18' },
    { title: 'Danışmanlık Hizmetlerimiz Genişliyor', excerpt: 'Teşvik ve proje danışmanlığı hizmetlerimize yeni başlıklar eklendi. KOSGEB, Mesem ve Kalkınma Ajansı destekleri.', date: '2025-01-10' },
    { title: 'Eğitim Merkezimizde Yüz Yüze Eğitimler Devam Ediyor', excerpt: 'Pandemi sonrası yüz yüze eğitim programlarımız hakkında güncel bilgi ve hijyen önlemleri.', date: '2024-12-15' }
  ];

  const handleLoadMockNews = async () => {
    if (!window.confirm(MOCK_NEWS.length + ' adet örnek haber eklenecek. Devam?')) return;
    const newsRef = ref(database, 'news');
    for (const item of MOCK_NEWS) {
      await push(newsRef, {
        title: item.title,
        excerpt: item.excerpt,
        content: item.excerpt,
        date: item.date,
        createdAt: new Date().toISOString()
      });
    }
    alert('Demo haber verisi yüklendi!');
  };

  // İletişim bilgilerini kaydet
  const handleSaveContactInfo = async (e) => {
    e.preventDefault();
    const contactRef = ref(database, 'contactInfo');
    await set(contactRef, contactInfo);
    alert('İletişim bilgileri kaydedildi!');
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-login">
        <div className="login-box">
          <h2>Admin Girişi</h2>
          <form onSubmit={handleLogin}>
            <input
              type="password"
              placeholder="Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Giriş Yap</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <h1>Admin Panel</h1>
        <button onClick={() => setIsAuthenticated(false)} className="logout-btn">
          Çıkış Yap
        </button>
      </div>

      <div className="admin-tabs">
        <button
          className={`tab-button ${activeTab === 'products' ? 'active' : ''}`}
          onClick={() => setActiveTab('products')}
        >
          Hizmetler
        </button>
        <button
          className={`tab-button ${activeTab === 'faq' ? 'active' : ''}`}
          onClick={() => setActiveTab('faq')}
        >
          S.S.S.
        </button>
        <button
          className={`tab-button ${activeTab === 'blog' ? 'active' : ''}`}
          onClick={() => setActiveTab('blog')}
        >
          Blog
        </button>
        <button
          className={`tab-button ${activeTab === 'news' ? 'active' : ''}`}
          onClick={() => setActiveTab('news')}
        >
          Haberler
        </button>
        <button
          className={`tab-button ${activeTab === 'contact' ? 'active' : ''}`}
          onClick={() => setActiveTab('contact')}
        >
          İletişim Bilgileri
        </button>
      </div>

      <div className="admin-content">
        {/* Hizmetler Sekmesi */}
        {activeTab === 'products' && (
          <div className="admin-section">
            <h2>Hizmetler (Başlık + Alt Hizmetler)</h2>
            <button type="button" onClick={handleLoadMockProductCategories} className="mock-data-btn">
              Demo Veri Yükle (Mesleki yeterlik, İSO, Danışmanlık)
            </button>
            <form onSubmit={handleAddCategory} className="admin-form">
              <input
                type="text"
                placeholder="Yeni başlık (kategori) adı"
                value={newCategoryTitle}
                onChange={(e) => setNewCategoryTitle(e.target.value)}
                required
              />
              <button type="submit">Başlık Ekle</button>
            </form>

            <div className="product-categories-list">
              {productCategories.length === 0 ? (
                <p className="empty-message">Henüz başlık eklenmemiş. Demo veri yükleyebilir veya yukarıdan başlık ekleyin.</p>
              ) : (
                productCategories.map((cat) => (
                  <div key={cat.id} className="product-category-block">
                    <div className="product-category-header">
                      <h3 className="product-category-title">{cat.title}</h3>
                      <button type="button" onClick={() => handleDeleteCategory(cat.id)} className="delete-btn">Başlığı Sil</button>
                    </div>
                    <form onSubmit={(e) => handleAddSubCategory(e, cat.id)} className="admin-form product-subcategory-form">
                      <input
                        type="text"
                        placeholder="Alt başlık adı"
                        value={newSubCategoryTitleByCat[cat.id] || ''}
                        onChange={(e) => setNewSubCategoryTitleByCat(prev => ({ ...prev, [cat.id]: e.target.value }))}
                      />
                      <button type="submit">Alt başlık ekle</button>
                    </form>
                    {(cat.subCategories || []).map((sub) => (
                      <div key={sub.id} className="product-subcategory-block">
                        <div className="product-subcategory-header">
                          <h4 className="product-subcategory-title">{sub.title}</h4>
                          {sub.id !== 'genel' && (
                            <button type="button" onClick={() => handleDeleteSubCategory(cat.id, sub.id)} className="delete-btn small">Alt başlığı sil</button>
                          )}
                        </div>
                        <form onSubmit={(e) => handleAddProductItem(e, cat.id, sub.id)} className="admin-form product-item-form">
                          <input
                            type="text"
                            placeholder="Hizmet adı"
                            value={typeof newItemBySubCategory[`${cat.id}_${sub.id}`] === 'object' ? (newItemBySubCategory[`${cat.id}_${sub.id}`]?.title || '') : (newItemByCategory[cat.id] && typeof newItemByCategory[cat.id] === 'object' ? newItemByCategory[cat.id].title : '')}
                            onChange={(e) => setNewItemBySubCategory(prev => ({
                              ...prev,
                              [`${cat.id}_${sub.id}`]: { ...(prev[`${cat.id}_${sub.id}`] || {}), title: e.target.value, description: (prev[`${cat.id}_${sub.id}`]?.description) || '' }
                            }))}
                            required
                          />
                          <textarea
                            placeholder="Açıklama (opsiyonel)"
                            value={typeof newItemBySubCategory[`${cat.id}_${sub.id}`] === 'object' ? (newItemBySubCategory[`${cat.id}_${sub.id}`]?.description || '') : (newItemByCategory[cat.id] && typeof newItemByCategory[cat.id] === 'object' ? newItemByCategory[cat.id].description : '')}
                            onChange={(e) => setNewItemBySubCategory(prev => ({
                              ...prev,
                              [`${cat.id}_${sub.id}`]: { ...(prev[`${cat.id}_${sub.id}`] || {}), title: (prev[`${cat.id}_${sub.id}`]?.title) || '', description: e.target.value }
                            }))}
                            rows={2}
                          />
                          <textarea
                            placeholder="Detay sayfası içeriği (opsiyonel, uzun açıklama)"
                            value={typeof newItemBySubCategory[`${cat.id}_${sub.id}`] === 'object' ? (newItemBySubCategory[`${cat.id}_${sub.id}`]?.content || '') : ''}
                            onChange={(e) => setNewItemBySubCategory(prev => ({
                              ...prev,
                              [`${cat.id}_${sub.id}`]: { ...(prev[`${cat.id}_${sub.id}`] || {}), title: (prev[`${cat.id}_${sub.id}`]?.title) || '', description: (prev[`${cat.id}_${sub.id}`]?.description) || '', content: e.target.value }
                            }))}
                            rows={4}
                          />
                          <button type="submit">Hizmet ekle</button>
                        </form>
                        <ul className="product-items-under-category">
                          {(sub.items || []).length === 0 ? (
                            <li className="empty-sub">Bu alt başlık altında henüz hizmet yok.</li>
                          ) : (
                            (sub.items || []).map((item) => (
                              <li key={item.id}>
                                <div className="product-item-in-list">
                                  <strong>{item.title}</strong>
                                  {item.description ? <p className="product-item-desc">{item.description}</p> : null}
                                </div>
                                <button type="button" onClick={() => handleDeleteProductItem(cat.id, sub.id, item.id)} className="delete-btn small">Sil</button>
                              </li>
                            ))
                          )}
                        </ul>
                      </div>
                    ))}
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* S.S.S. Sekmesi */}
        {activeTab === 'faq' && (
          <div className="admin-section">
            <h2>Sıkça Sorulan Sorular</h2>
            <button type="button" onClick={handleLoadMockFaq} className="mock-data-btn">
              Demo S.S.S. Verisi Yükle
            </button>
            <form onSubmit={handleAddFaq} className="admin-form">
              <input
                type="text"
                placeholder="Soru"
                value={newFaq.question}
                onChange={(e) => setNewFaq({ ...newFaq, question: e.target.value })}
                required
              />
              <textarea
                placeholder="Cevap"
                value={newFaq.answer}
                onChange={(e) => setNewFaq({ ...newFaq, answer: e.target.value })}
                required
              />
              <button type="submit">Soru Ekle</button>
            </form>
            <div className="items-list">
              {faqs.length === 0 ? (
                <p className="empty-message">Henüz soru eklenmemiş.</p>
              ) : (
                faqs.map((item) => (
                  <div key={item.id} className="item-card">
                    <h3>{item.question}</h3>
                    <p>{item.answer}</p>
                    <button onClick={() => handleDeleteFaq(item.id)} className="delete-btn">Sil</button>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* Blog Sekmesi */}
        {activeTab === 'blog' && (
          <div className="admin-section">
            <h2>Blog</h2>
            <button type="button" onClick={handleLoadMockBlog} className="mock-data-btn">
              Demo Blog Verisi Yükle
            </button>
            <form onSubmit={handleAddBlog} className="admin-form">
              <input
                type="text"
                placeholder="Başlık"
                value={newBlog.title}
                onChange={(e) => setNewBlog({ ...newBlog, title: e.target.value })}
                required
              />
              <input
                type="text"
                placeholder="Tarih (YYYY-MM-DD veya boş bırakın)"
                value={newBlog.date}
                onChange={(e) => setNewBlog({ ...newBlog, date: e.target.value })}
              />
              <textarea
                placeholder="Özet / İçerik"
                value={newBlog.excerpt}
                onChange={(e) => setNewBlog({ ...newBlog, excerpt: e.target.value, content: e.target.value })}
                required
              />
              <button type="submit">Yazı Ekle</button>
            </form>
            <div className="items-list">
              {blogPosts.length === 0 ? (
                <p className="empty-message">Henüz blog yazısı eklenmemiş.</p>
              ) : (
                blogPosts.map((post) => (
                  <div key={post.id} className="item-card">
                    <h3>{post.title}</h3>
                    <p>{post.excerpt || post.content}</p>
                    <button onClick={() => handleDeleteBlog(post.id)} className="delete-btn">Sil</button>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* Haberler Sekmesi */}
        {activeTab === 'news' && (
          <div className="admin-section">
            <h2>Haberler</h2>
            <button type="button" onClick={handleLoadMockNews} className="mock-data-btn">
              Demo Haber Verisi Yükle
            </button>
            <form onSubmit={handleAddNews} className="admin-form">
              <input
                type="text"
                placeholder="Başlık"
                value={newNews.title}
                onChange={(e) => setNewNews({ ...newNews, title: e.target.value })}
                required
              />
              <input
                type="text"
                placeholder="Tarih (YYYY-MM-DD veya boş bırakın)"
                value={newNews.date}
                onChange={(e) => setNewNews({ ...newNews, date: e.target.value })}
              />
              <textarea
                placeholder="Özet / İçerik"
                value={newNews.excerpt}
                onChange={(e) => setNewNews({ ...newNews, excerpt: e.target.value, content: e.target.value })}
                required
              />
              <button type="submit">Haber Ekle</button>
            </form>
            <div className="items-list">
              {newsItems.length === 0 ? (
                <p className="empty-message">Henüz haber eklenmemiş.</p>
              ) : (
                newsItems.map((item) => (
                  <div key={item.id} className="item-card">
                    <h3>{item.title}</h3>
                    <p>{item.excerpt || item.content}</p>
                    <button onClick={() => handleDeleteNews(item.id)} className="delete-btn">Sil</button>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* İletişim Bilgileri Sekmesi */}
        {activeTab === 'contact' && (
          <div className="admin-section">
            <h2>İletişim Bilgileri</h2>
            <form onSubmit={handleSaveContactInfo} className="admin-form">
              <div className="form-group">
                <label>Telefon</label>
                <input
                  type="text"
                  value={contactInfo.phone}
                  onChange={(e) => setContactInfo({ ...contactInfo, phone: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>E-posta</label>
                <input
                  type="email"
                  value={contactInfo.email}
                  onChange={(e) => setContactInfo({ ...contactInfo, email: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Adres</label>
                <textarea
                  value={contactInfo.address}
                  onChange={(e) => setContactInfo({ ...contactInfo, address: e.target.value })}
                  required
                  rows="3"
                />
              </div>
              <div className="form-group">
                <label>Çalışma Saatleri</label>
                <textarea
                  value={contactInfo.workingHours}
                  onChange={(e) => setContactInfo({ ...contactInfo, workingHours: e.target.value })}
                  required
                  rows="3"
                />
              </div>
              <div className="form-group">
                <label>YouTube (profil veya kanal linki)</label>
                <input
                  type="url"
                  placeholder="https://youtube.com/@..."
                  value={contactInfo.youtube || ''}
                  onChange={(e) => setContactInfo({ ...contactInfo, youtube: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Instagram (profil linki)</label>
                <input
                  type="url"
                  placeholder="https://instagram.com/..."
                  value={contactInfo.instagram || ''}
                  onChange={(e) => setContactInfo({ ...contactInfo, instagram: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>TikTok (profil linki)</label>
                <input
                  type="url"
                  placeholder="https://tiktok.com/@..."
                  value={contactInfo.tiktok || ''}
                  onChange={(e) => setContactInfo({ ...contactInfo, tiktok: e.target.value })}
                />
              </div>
              <button type="submit" className="save-btn">Kaydet</button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPanel;
